module.exports = __webpack_public_path__ + "static/media/georgiana_riglea.052e687e.png";